/**
 * PDP Editorial Slider
 * Daily Harvest style auto-sliding product images
 */

function initEditorialSlider() {
  const sliders = document.querySelectorAll('.editorial-slideshow');
  
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('.editorial-slide');
    const speed = parseInt(slider.dataset.speed) * 1000 || 2000;
    const isAutoplay = slider.dataset.autoplay === 'true';
    
    if (slides.length <= 1) return;
    
    let currentSlide = 0;
    let slideshowInterval;
    let touchstartX = 0;
    let touchendX = 0;

    const prevButton = slider.querySelector('.editorial-nav-button--prev');
    const nextButton = slider.querySelector('.editorial-nav-button--next');

    function showSlide(index) {
      currentSlide = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('editorial-slide--active', i === currentSlide);
      });
    }
    
    function next() {
      showSlide(currentSlide + 1);
    }

    function prev() {
      showSlide(currentSlide - 1);
    }
    
    function startSlideshow() {
      if (!isAutoplay) return;
      return setInterval(next, speed);
    }
    
    function stopSlideshow() {
      clearInterval(slideshowInterval);
    }

    function handleGesture() {
      if (touchendX < touchstartX) next();
      if (touchendX > touchstartX) prev();
    }

    // Event Listeners
    if (nextButton && prevButton) {
      nextButton.addEventListener('click', () => {
        next();
        stopSlideshow();
      });
      prevButton.addEventListener('click', () => {
        prev();
        stopSlideshow();
      });
    }

    slider.addEventListener('touchstart', e => {
      touchstartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slider.addEventListener('touchend', e => {
      touchendX = e.changedTouches[0].screenX;
      handleGesture();
    }, { passive: true });
    
    // Initialize first slide
    showSlide(0);
    
    // Autoplay
    slideshowInterval = startSlideshow();
    
    // Pause on hover (desktop only)
    if (window.innerWidth >= 768) {
      slider.addEventListener('mouseenter', stopSlideshow);
      slider.addEventListener('mouseleave', () => {
        slideshowInterval = startSlideshow();
      });
    }
  });
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initEditorialSlider);

// Reinitialize for theme editor
document.addEventListener('shopify:section:load', initEditorialSlider);